import { defineStore } from 'pinia'

import type { TutorApplicationStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useTutorApplicationStore = defineStore('tutorApplication', {
  state: (): TutorApplicationStore => ({
    fullName: '',
    email: '',
    phoneNumber: '',
    cv: null,
    coverLetter: null,
    nationality: '',
    ageConfirmation: null,
    recommended: null,
    referrerFullName: '',
    referralSource: null,
    jobPostingSite: '',
    hasBachelorDegree: null,
    teachingExperienceYears: null,
    workRequiredSchedule: null,
    onboardingTimeframe: null,
    acceptEmailDelivery: false,
    acceptConfidentiality: false,
    acceptNotRestrictedResident: false,
    acceptDataProcessingTerms: false,
    emailValid: false,
    showErrors: false,
    amplitudeId: null,
  }),
  actions,
  getters,
})
